// Hinweise der Sicherheitsleiste nach der Anmeldung (web/shell/SecurityBanner.tsx), die die Person für diese Anmeldung
// ausgeblendet hat. Gemerkt je Tab (sessionStorage) – die nächste Anmeldung zeigt sie wieder (establishSession).
// Nur eine Bequemlichkeit: Ohne Speicher (privates Fenster, gesperrt) gilt das Ausblenden bis zum Neuladen.
import { create } from 'zustand'
import { brand } from '@shared/brand'

export const SECURITY_NOTICES = ['mfaDue', 'recoveryLow', 'failedLogins'] as const
export type SecurityNotice = (typeof SECURITY_NOTICES)[number]

const STORAGE_KEY = `${brand.storagePrefix}.securityNotices`

function read(): SecurityNotice[] {
  try {
    const raw = globalThis.sessionStorage?.getItem(STORAGE_KEY)
    const parsed: unknown = raw ? JSON.parse(raw) : []
    return Array.isArray(parsed) ? parsed.filter((entry): entry is SecurityNotice => SECURITY_NOTICES.includes(entry as SecurityNotice)) : []
  } catch {
    return []
  }
}

function write(dismissed: readonly SecurityNotice[]): void {
  try {
    if (dismissed.length === 0) globalThis.sessionStorage?.removeItem(STORAGE_KEY)
    else globalThis.sessionStorage?.setItem(STORAGE_KEY, JSON.stringify(dismissed))
  } catch {
    // ohne Speicher: nur im Arbeitsspeicher
  }
}

export const useSecurityNotices = create<{ dismissed: SecurityNotice[] }>(() => ({ dismissed: read() }))

export function dismissSecurityNotice(notice: SecurityNotice): void {
  const dismissed = [...new Set([...useSecurityNotices.getState().dismissed, notice])]
  write(dismissed)
  useSecurityNotices.setState({ dismissed })
}

/** Neue Anmeldung: alle Hinweise gelten wieder. */
export function resetSecurityNotices(): void {
  write([])
  useSecurityNotices.setState({ dismissed: [] })
}
